import { FC, useEffect, useRef, useState } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import InputData from "../Model/InputData";
import { vestResolver } from "@hookform/resolvers/vest";
import { UseSalarySimContext } from "../Context/SalarySimContext";
import { FormSuite } from "../FormModel/FormValidator_Step3_Advanced";
import { SalSimFormProps } from "../FormModel/FormStepProps";
import { UseTranslationContext } from "../Context/TranslationContext";
import FormToggleElementDualChoice from "./FormToggleElementDualChoice";
import MUITooltipCustom from "./MUITooltipCustom";
import { Checkbox } from "@mui/material";
import { UseCodeListContext } from "../Context/CodeListContext";

const Step3Advanced: FC<SalSimFormProps> = (props) => {
    const getSectionImgStyle = () => {
        return {
            WebkitTransform: "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)",
            ["MozTransform" as any]: "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)",
            ["MsTransform" as any]: "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)",
            transform: "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0deg) skew(0, 0)"
        } as React.CSSProperties;
    };

    const {restrictedFieldEndOfYearBonus, restrictedFieldGrossSubmitted} = UseCodeListContext();

   
    // { Temporary fix for sections not toggling correctly
    const [section1, setSection1] = useState(false);
    const [section2, setSection2] = useState(false);
    const [section3, setSection3] = useState(false);
    const [section4, setSection4] = useState(false);
    const [section5, setSection5] = useState(false);

    const toggleSection = (item: number) => {
        switch (item) {
            case (1):
                setSection1(!section1)
                break;
            case (2):
                setSection2(!section2)
                break;
            case (3):
                setSection3(!section3)
                break;
            case (4):
                setSection4(!section4)
                break;
            case (5):
                setSection5(!section5)
                break;
        }
    }

    const getSectionTogglerStyle = (isSectionToggled: boolean) => {
        let hiddenCss = { height: "56px" } as React.CSSProperties;
        let shownCss = {} as React.CSSProperties;
        return isSectionToggled ? shownCss : hiddenCss;
    };
    // } END temporary fix

    const { salarySimAdvancedFormData, updateSalarySimData } = UseSalarySimContext();
    const { getKeyFromKeyId } = UseTranslationContext();
    const { register, handleSubmit, setValue, formState: { errors }, control } = useForm({
        resolver: vestResolver(FormSuite),
        mode: 'onChange',
        reValidateMode: 'onChange',
        context: undefined,
        criteriaMode: "firstError",
        shouldFocusError: false,
        shouldUnregister: false,
        delayError: undefined,
        
        defaultValues: {
            NetToBrutCheck : false,
            MonthlyAmount : 0,
            ProfDeductionAmount : 0,
            GrossSubmittedAmount:0,
            NetBenefitAmount : 0,
            NetCarBenefitAmount : 0,
            HasWorkHomeBenefit : false,
            CollectiveInsuranceAmount : 0,
            OtherNegativeAmount : 0,
            OtherPositiveAmount : 0,
            CollectiveInsuranceEmployeurIntervAmount : 0,
            Commissions:0,
            EndYearBonusAmount : 0,
            EndYearBonusAmountForemSubmitted:0,
            EndYearBonusAmountForemNotSubmitted:0,
            NonReccurentDirectorAmount : 0,
            MonthlyCopyrightAmount : 0,
            CurrentDoubleBonusAmount : 0,
            CurrentAdditionalBonusAmount : 0,
            PreviousBonusAmount : 0,
            PreviousDoubleBonusAmount : 0,
            PreviousAdditionalBonusAmount : 0,
            AdvanceBonusAmount : 0,
            AdvanceDoubleBonusAmount : 0,
            AdvanceAdditionalBonusAmount : 0,
            PublicTransportationAmount : 0,
            PrivateTransportationAmount : 0
        }
    });

          // LOADING PRESTA
          useEffect(() => {
            if(salarySimAdvancedFormData != null)
            {
              if(salarySimAdvancedFormData.loadFromPresta == true)
              {
                setValue("NetToBrutCheck", salarySimAdvancedFormData.NetToBrut);
                setValue("MonthlyAmount", salarySimAdvancedFormData.MonthlyAmount,{ shouldValidate: true});
                setValue("ProfDeductionAmount", salarySimAdvancedFormData.ProfDeductionAmount,{ shouldValidate: true});
                setValue("GrossSubmittedAmount", salarySimAdvancedFormData.GrossSubmittedAmount,{ shouldValidate: true});
                setValue("NetBenefitAmount", salarySimAdvancedFormData.NetBenefitAmount,{ shouldValidate: true});
                setValue("NetCarBenefitAmount", salarySimAdvancedFormData.NetCarBenefitAmount,{ shouldValidate: true});
                setValue("HasWorkHomeBenefit", ((salarySimAdvancedFormData.HasWorkHomeBenefit == true )?true:false));

                setValue("CollectiveInsuranceAmount", salarySimAdvancedFormData.CollectiveInsuranceAmount,{ shouldValidate: true});
                setValue("OtherNegativeAmount", salarySimAdvancedFormData.OtherNegativeAmount,{ shouldValidate: true});
                setValue("OtherPositiveAmount", salarySimAdvancedFormData.OtherPositiveAmount,{ shouldValidate: true});
                setValue("CollectiveInsuranceEmployeurIntervAmount", salarySimAdvancedFormData.CollectiveInsuranceEmployeurIntervAmount,{ shouldValidate: true});

                if(showEndYearBonusAmount)
                {
                    setValue("EndYearBonusAmount", salarySimAdvancedFormData.EndYearBonusAmount,{ shouldValidate: true});
                    setValue("EndYearBonusAmountForemNotSubmitted", 0,{ shouldValidate: true});
                    setValue("EndYearBonusAmountForemSubmitted", 0,{ shouldValidate: true});
                }
                else
                {
                    setValue("EndYearBonusAmount", 0,{ shouldValidate: true});
                    setValue("EndYearBonusAmountForemNotSubmitted", salarySimAdvancedFormData.EndYearBonusAmountForemNotSubmitted,{ shouldValidate: true});
                    setValue("EndYearBonusAmountForemSubmitted", salarySimAdvancedFormData.EndYearBonusAmountForemSubmitted,{ shouldValidate: true});
                }
                
                setValue("Commissions", salarySimAdvancedFormData.Commissions,{ shouldValidate: true});

                setValue("NonReccurentDirectorAmount", salarySimAdvancedFormData.NonReccurentDirectorAmount,{ shouldValidate: true});
                setValue("MonthlyCopyrightAmount", salarySimAdvancedFormData.MonthlyCopyrightAmount,{ shouldValidate: true});
                setValue("CurrentDoubleBonusAmount", salarySimAdvancedFormData.CurrentDoubleBonusAmount,{ shouldValidate: true});
                setValue("CurrentAdditionalBonusAmount", salarySimAdvancedFormData.CurrentAdditionalBonusAmount,{ shouldValidate: true});
                setValue("PreviousBonusAmount", salarySimAdvancedFormData.PreviousBonusAmount,{ shouldValidate: true});
                setValue("PreviousDoubleBonusAmount", salarySimAdvancedFormData.PreviousDoubleBonusAmount,{ shouldValidate: true});
                setValue("PreviousAdditionalBonusAmount", salarySimAdvancedFormData.PreviousAdditionalBonusAmount,{ shouldValidate: true});
                setValue("AdvanceBonusAmount", salarySimAdvancedFormData.AdvanceBonusAmount,{ shouldValidate: true});
                setValue("AdvanceDoubleBonusAmount", salarySimAdvancedFormData.AdvanceDoubleBonusAmount,{ shouldValidate: true});
                setValue("AdvanceAdditionalBonusAmount", salarySimAdvancedFormData.AdvanceAdditionalBonusAmount,{ shouldValidate: true});
                setValue("PublicTransportationAmount", salarySimAdvancedFormData.PublicTransportationAmount,{ shouldValidate: true});
                setValue("PrivateTransportationAmount", salarySimAdvancedFormData.PrivateTransportationAmount,{ shouldValidate: true});
    
                props.formPrestaLoaded(3);
              }
            }
    
          }, [salarySimAdvancedFormData]);

    const[showEndYearBonusAmount,setShowEndYearBonusAmount]=useState(false);
    const[showEndYearBonusAmountForem,setShowEndYearBonusAmountForem]=useState(false);
    const[showGrossSubmittedAmount,setShowGrossSubmittedAmount]=useState(false);
  


    useEffect(()=>{
        let currentContractType = salarySimAdvancedFormData.ContractType;

        if(restrictedFieldEndOfYearBonus && restrictedFieldEndOfYearBonus.some(x => x == currentContractType.toString())) // 675
        {
            setShowEndYearBonusAmountForem(true);
            setShowEndYearBonusAmount(false);
        }else{
            setShowEndYearBonusAmountForem(false);
            setShowEndYearBonusAmount(true);
        }

        let currentOnssPrefix=parseInt(salarySimAdvancedFormData.OnssPrefix);
        if(restrictedFieldGrossSubmitted && restrictedFieldGrossSubmitted.some(x => x == currentOnssPrefix.toString())) // 96
        {
            setShowGrossSubmittedAmount(true);
        }else{
            setShowGrossSubmittedAmount(false);
        }


    },[salarySimAdvancedFormData.ContractType, salarySimAdvancedFormData.OnssPrefix, restrictedFieldEndOfYearBonus, restrictedFieldGrossSubmitted])



    const formNetToBrutCheck = useWatch({ control, name: "NetToBrutCheck", defaultValue: (salarySimAdvancedFormData.NetToBrut != undefined) ? salarySimAdvancedFormData.NetToBrut : true });
    const formAmount = useWatch({ control, name: "MonthlyAmount" });

    const formRef = useRef<HTMLFormElement>(null);
    useEffect(() => {
        if (props.requestFormValidation != null && props.requestFormValidation.includes(props.formStep) && formRef.current) {
          formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      },[props.requestFormValidation])

    //send after validation
    const SendSalarySimForm = (data: any, goToNext: boolean = true) => {
       
        let updateData = new InputData();
        updateData.NetToBrut = data?.NetToBrutCheck;
        updateData.MonthlyAmount = parseFloat(data?.MonthlyAmount);
        updateData.ProfDeductionAmount = parseFloat(data?.ProfDeductionAmount);
        updateData.GrossSubmittedAmount=parseFloat(data?.GrossSubmittedAmount);
        updateData.NetBenefitAmount = parseFloat(data?.NetBenefitAmount);
        updateData.NetCarBenefitAmount = parseFloat(data?.NetCarBenefitAmount);
        updateData.HasWorkHomeBenefit = data?.HasWorkHomeBenefit;

        updateData.CollectiveInsuranceAmount = parseFloat(data?.CollectiveInsuranceAmount);
        updateData.OtherNegativeAmount = parseFloat(data?.OtherNegativeAmount);
        updateData.OtherPositiveAmount = parseFloat(data?.OtherPositiveAmount);
        updateData.CollectiveInsuranceEmployeurIntervAmount = parseFloat(data?.CollectiveInsuranceEmployeurIntervAmount);

        if(showEndYearBonusAmount)
        {   updateData.EndYearBonusAmount = parseFloat(data?.EndYearBonusAmount);
            updateData.EndYearBonusAmountForemNotSubmitted=0;
            updateData.EndYearBonusAmountForemSubmitted=0;
        }else{
            updateData.EndYearBonusAmount = 0;
            updateData.EndYearBonusAmountForemNotSubmitted=parseFloat(data?.EndYearBonusAmountForemNotSubmitted);
            updateData.EndYearBonusAmountForemSubmitted=parseFloat(data?.EndYearBonusAmountForemSubmitted);
        }
        

        updateData.Commissions=parseFloat(data?.Commissions);
        
        updateData.NonReccurentDirectorAmount = parseFloat(data?.NonReccurentDirectorAmount);
        updateData.MonthlyCopyrightAmount = parseFloat(data?.MonthlyCopyrightAmount);
        updateData.CurrentDoubleBonusAmount = parseFloat(data?.CurrentDoubleBonusAmount);
        updateData.CurrentAdditionalBonusAmount = parseFloat(data?.CurrentAdditionalBonusAmount);
        updateData.PreviousBonusAmount = parseFloat(data?.PreviousBonusAmount);
        updateData.PreviousDoubleBonusAmount = parseFloat(data?.PreviousDoubleBonusAmount);
        updateData.PreviousAdditionalBonusAmount = parseFloat(data?.PreviousAdditionalBonusAmount);
        updateData.AdvanceBonusAmount = parseFloat(data?.AdvanceBonusAmount);
        updateData.AdvanceDoubleBonusAmount = parseFloat(data?.AdvanceDoubleBonusAmount);
        updateData.AdvanceAdditionalBonusAmount = parseFloat(data?.AdvanceAdditionalBonusAmount);
        updateData.PublicTransportationAmount = parseFloat(data?.PublicTransportationAmount);
        updateData.PrivateTransportationAmount = parseFloat(data?.PrivateTransportationAmount);

       

        if (updateSalarySimData != undefined)
            updateSalarySimData(updateData, 3, false);

        props.formValidationCallback(props.formStep, true);
    }

    const onFormError = (formErrors : any, e : any) =>{
        props.formValidationCallback(props.formStep, false);
    };

    const ToggleBruttoNetState = (onState : boolean) => {
        setValue("NetToBrutCheck", onState);

        if(formAmount > 0)
        {
          setValue("MonthlyAmount", formAmount, {shouldValidate : true, shouldDirty: true});
        }
    };

    const GetInputFieldCssClass = (inError: boolean) => {
        return ( inError?'text-field w-input inputFixedMaxHeight inputFieldError':'text-field w-input inputFixedMaxHeight' );
      }

    return (
        <>
            <div style={{ display: !props.isCurrentForm ? "none" : "" }}>
                <form ref={formRef} id="formStep3Advanced" onSubmit={handleSubmit((d) => SendSalarySimForm(d), (data, e) => onFormError(data,e))} name="wf-form-Etape3-avanc" data-name="Etape3-avancé" method="post" aria-label={getKeyFromKeyId("SECTION_AMOUNT")} className="form-step3-avance formIndex">

                    <div className="toggleTwoColumn">
                    <FormToggleElementDualChoice defaultValueState={formNetToBrutCheck} translationTitle={getKeyFromKeyId("CALCULATION_DIRECTION")} translationValueLeft={getKeyFromKeyId("BRUT")} translationValueRight={getKeyFromKeyId("NET")} valueUpdateCallback={ToggleBruttoNetState} cssClass={"group-toggle-half"} id={"w-node-f1b42f4b-c06c-5470-5f25-61acf5df48d6-80011528"}/>
                        {formNetToBrutCheck && <p className="legend input">{getKeyFromKeyId("WARNING_NET_TO_BRUT_SPEED")}</p> }
                    </div>

                    <div id="group-field-montant" className="group-field">
                        <div className="group-label">
                            <label aria-hidden="true" htmlFor="money" className="field-label">{`${getKeyFromKeyId(formNetToBrutCheck?"MONTHLY_AMOUNT_NET":"MONTHLY_AMOUNT_BRUT")} (${getKeyFromKeyId("MANDATORY_FIELD")})`}</label>
                        </div>
                        <div className="text-field-icon">
                            <input type="number" {...register("MonthlyAmount")}className={GetInputFieldCssClass(errors?.MonthlyAmount?true:false)}maxLength={256} placeholder="0 €" id="money" />
                        </div>
                        {errors?.MonthlyAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.MonthlyAmount.message as any)}</p>}
                    </div>

                    <div id="group-field-montant-pp" className="group-field">
                        <div className="group-label">
                            <label aria-hidden="true" htmlFor="money-pp" className="field-label">{getKeyFromKeyId("MONTANT_IMPOSABLE_PP_ORDINAIRE")}</label>
                        </div>
                        <div className="text-field-icon">
                            <input type="number" {...register("ProfDeductionAmount")}className={GetInputFieldCssClass(errors?.ProfDeductionAmount?true:false)}maxLength={256} placeholder="0 €" id="money-pp" />
                        </div>
                        {errors?.ProfDeductionAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.ProfDeductionAmount.message as any)}</p>}
                    </div>

                    {showGrossSubmittedAmount &&
                    <div id="group_field_gross_submited" className="group-field toggleTwoColumn inputFixedWidth">
                        <div className="group-label">
                            <label aria-hidden="true" htmlFor="money-pp" className="field-label">{getKeyFromKeyId("MONTANT_BRUT_SOUMIS_PP")}</label>
                        </div>
                        <div className="text-field-icon">
                            <input type="number" {...register("GrossSubmittedAmount")}className={GetInputFieldCssClass(errors?.GrossSubmittedAmount?true:false)}maxLength={256} placeholder="0 €" id="money-pp" />
                        </div>
                        {errors?.GrossSubmittedAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.GrossSubmittedAmount.message as any)}</p>}
                    </div> 
                    }


                    <div id="column-left" className="column-composants w-node-_9511720b-e599-5fcb-7f41-b9864a397170-80011528">
                        <section id="section-avantages" data-w-id="c97fd2b2-e356-35ed-e116-3f3c1188b0f5" style={getSectionTogglerStyle(section1)} className="section-composants">
                            <div id="dropdown-title-avantages" tabIndex={0} data-w-id="e876c378-1bc6-9af3-9d1d-c0ce444b054a" className="dropdow-titre" onClick={() => toggleSection(1)}>
                                <h2 className="title-section-composants">{getKeyFromKeyId("BENEFITS")}</h2>
                                <img loading="lazy" style={getSectionImgStyle()} data-w-id="4fcba0bc-0444-67d1-8b96-83b378e1c77f" alt="" className={"selectDropDownImg"} src="images/ic-down-celeste.svg" />
                            </div>
                            <div id="group-fields-avantages" className="content-composants">
                                <div id="group-field-net" className="group-field">
                                    <div className="group-label">
                                        <label aria-hidden="true" htmlFor="avantages-nature" className="field-label">{getKeyFromKeyId("BENEFITS_KIND_NET")}</label>
                                    </div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("NetBenefitAmount")}className={GetInputFieldCssClass(errors?.NetBenefitAmount?true:false)}maxLength={256} placeholder="0 €" id="avantages-nature" />
                                    </div>
                                    {errors?.NetBenefitAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.NetBenefitAmount.message as any)}</p>}
                                </div>
                                <div id="group-field-voiture" className="group-field">
                                    <div className="group-label">
                                        <label aria-hidden="true" htmlFor="avantages-voiture" className="field-label">{getKeyFromKeyId("BENEFITS_CAR_NET")}</label>
                                    </div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("NetCarBenefitAmount")}className={GetInputFieldCssClass(errors?.NetCarBenefitAmount?true:false)}maxLength={256} placeholder="0 €" id="avantages-voiture" />
                                    </div>
                                    {errors?.NetCarBenefitAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.NetCarBenefitAmount.message as any)}</p>}
                                </div>
                                <div id="group-field-avec-avantage" className="group-checkbox">
                                    <label id="w-node-c40b0803-013c-539a-ff85-130463b7ed80-80011528" className="w-checkbox checkbox-field margin" htmlFor="HasWorkHomeBenefit">
                                    <Controller
                                        name="HasWorkHomeBenefit"
                                        control={control}
                                        defaultValue={false}
                                        render={({ field: { value, ref, ...field } }) => (
                                        <Checkbox size="medium" id="HasWorkHomeBenefit" aria-label={getKeyFromKeyId("AVEC_AVANTAGE_DOM_TRAVAIL")}
                                            {...field}
                                            checked={!!value}
                                            sx={{
                                                color: '#90BBB5',
                                                '&.Mui-checked': {
                                                    color: '#90BBB5',
                                                }   
                                            }} />
                                        )}
                                    />

                                        <span aria-hidden="true" className="checkbox-label w-form-label" /*htmlFor="Checkbox-2"*/>{getKeyFromKeyId("AVEC_AVANTAGE_DOM_TRAVAIL")}</span>
                                        
                                    </label>
                                </div>
                                <div id="group-field-assurance-groupe" className="group-field">
                                    <div className="group-label">
                                        <label aria-hidden=/*"hidden"*/"true" htmlFor="assurance-groupe" className="field-label">{getKeyFromKeyId("BENEFITS_WORKER_INSUR_NET")}</label>
                                        <MUITooltipCustom tooltipText={getKeyFromKeyId("TOOLTIP_HELP_GROUP_INSURANCE")} buttonAltText={getKeyFromKeyId("TOOLTIP_HELP_ALT_INSURANCE")} placement="top"/>
                                        </div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("CollectiveInsuranceAmount")}className={GetInputFieldCssClass(errors?.CollectiveInsuranceAmount?true:false)}maxLength={256} placeholder="0 €" id="assurance-groupe" />
                                    </div>
                                    {errors?.CollectiveInsuranceAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.CollectiveInsuranceAmount.message as any)}</p>}
                                </div>
                                <div id="group-field-divers" className="group-field">
                                    <div className="group-label"><label aria-hidden="true" htmlFor="divers-nets" className="field-label">{`${getKeyFromKeyId("BENEFITS_OTHERS_NET")} (${getKeyFromKeyId("NEGATIVE")})`}</label></div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("OtherNegativeAmount")}className={GetInputFieldCssClass(errors?.OtherNegativeAmount?true:false)}maxLength={256} placeholder="0 €" id="divers-nets" />
                                    </div>
                                    {errors?.OtherNegativeAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.OtherNegativeAmount.message as any)}</p>}
                                </div>
                                <div id="group-field-divers-pos" className="group-field">
                                    <div className="group-label"><label aria-hidden="true" htmlFor="divers-nets-pos" className="field-label">{`${getKeyFromKeyId("BENEFITS_OTHERS_NET")} (${getKeyFromKeyId("POSITIVE")})`}</label></div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("OtherPositiveAmount")}className={GetInputFieldCssClass(errors?.OtherPositiveAmount?true:false)}maxLength={256} placeholder="0 €" id="divers-nets-pos" />
                                    </div>
                                    {errors?.OtherPositiveAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.OtherPositiveAmount.message as any)}</p>}
                                </div>
                            </div>
                        </section>
                        <section id="section-autres" data-w-id="33c83071-6a82-9f95-f726-6f140bace1b6" style={getSectionTogglerStyle(section2)} className="section-composants last-child w-node-_33c83071-6a82-9f95-f726-6f140bace1b6-4f6cf1d2">
                            <div id="dropdown-title-autres" tabIndex={0} data-w-id="5bd8e1ca-4c21-5ea1-0050-e154e59cfed0" className="dropdow-titre" onClick={() => toggleSection(2)}>
                                <h2 className="title-section-composants">{getKeyFromKeyId("OTHERS")}</h2><img loading="lazy" className={"selectDropDownImg"} src="images/ic-down-celeste.svg" alt="" />
                            </div>
                            <div id="group-fields-autres" className="content-composants">
                                <div id="group-field-patronale" className="group-field">
                                    <div className="group-label">
                                        <label aria-hidden="true" htmlFor="assurance-patronale" className="field-label">{getKeyFromKeyId("ASSURANCE_GROUPE_EMPL")}</label>
                                    </div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("CollectiveInsuranceEmployeurIntervAmount")}className={GetInputFieldCssClass(errors?.CollectiveInsuranceEmployeurIntervAmount?true:false)}maxLength={256} placeholder="0 €" id="assurance-patronale" />
                                    </div>
                                    {errors?.CollectiveInsuranceEmployeurIntervAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.CollectiveInsuranceEmployeurIntervAmount.message as any)}</p>}
                                </div>
                                
                                <div id="group-field-prime" className="group-field">
                                    <div className="group-label">
                                        <label aria-hidden="true" htmlFor="cash" className="field-label">{getKeyFromKeyId("COMMISSIONS")}</label>
                                    </div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("Commissions")}className={GetInputFieldCssClass(errors?.Commissions?true:false)}maxLength={256} placeholder="0 €" id="prime" />
                                    </div>
                                    {errors?.Commissions && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.Commissions.message as any)}</p>}
                                </div>

                                {showEndYearBonusAmount && 
                                <div id="group-field-prime" className="group-field">
                                    <div /*htmlFor="prime"*/ className="group-label">
                                        <label aria-hidden="true" htmlFor="cash" className="field-label">{getKeyFromKeyId("PRIME_FIN_ANNEE")}</label>
                                    </div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("EndYearBonusAmount")}className={GetInputFieldCssClass(errors?.EndYearBonusAmount?true:false)}maxLength={256} placeholder="0 €" id="prime" />
                                    </div>
                                    {errors?.EndYearBonusAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.EndYearBonusAmount.message as any)}</p>}
                                </div>
                                }
                                {/* this one seems to be a duplicate of a previous field
                    <div id="group-field-partie-pers" className="group-field">
                    <div className="group-label"><label aria-hidden="true" htmlFor="assurance-pers-net" className="field-label">Assurance groupe partie pers. net</label><img src="images/ic-info.svg" loading="lazy" id="w-node-_33c83071-6a82-9f95-f726-6f140bace1d0-80011528" role="button" alt="Plus d&#x27;informations à propos des assurances groupes" aria-describedby="tooltip" className="ic-info" /></div>
                    <div className="text-field-icon"><input type="number" className="text-field w-input" maxLength={256} name="assurance-pers-net" placeholder="0 €" id="assurance-pers-net-2" /></div>
                    </div> */}
                                <div id="group-field-remuneration" className="group-field">
                                    <div className="group-label"><label aria-hidden="true" htmlFor="Remuneration" className="field-label">{getKeyFromKeyId("REMUN_NON_PER")}</label></div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("NonReccurentDirectorAmount")}className={GetInputFieldCssClass(errors?.NonReccurentDirectorAmount?true:false)}maxLength={256} placeholder="0 €" id="Remuneration" />
                                    </div>
                                    {errors?.NonReccurentDirectorAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.NonReccurentDirectorAmount.message as any)}</p>}
                                </div>
                                <div id="group-field-droits" className="group-field">
                                    <div className="group-label"><label aria-hidden="true" htmlFor="droits" className="field-label">{getKeyFromKeyId("DROITS_AUTEUR")}</label></div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("MonthlyCopyrightAmount")}className={GetInputFieldCssClass(errors?.MonthlyCopyrightAmount?true:false)}maxLength={256} placeholder="0 €" id="droits" />
                                    </div>
                                    {errors?.MonthlyCopyrightAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.MonthlyCopyrightAmount.message as any)}</p>}
                                </div>
                            </div>
                        </section>

                        
                        {showEndYearBonusAmountForem && 
                        <section id="section-primefinannee" data-w-id="0bbf6d0c-e764-7d78-fb82-0f83dda7643f" style={getSectionTogglerStyle(section5)} className="section-composants w-node-_0bbf6d0c-e764-7d78-fb82-0f83dda7643f-80011528">
                            <div id="dropdown-title-primefinannee" tabIndex={0} data-w-id="b806931d-cb39-2257-1d76-ff6800467242" className="dropdow-titre" onClick={() => toggleSection(5)}>
                                <h2 className="title-section-composants">{getKeyFromKeyId("PRIME_FIN_ANNEE")}</h2><img loading="lazy" className={"selectDropDownImg"} src="images/ic-down-celeste.svg" alt="" />
                            </div>
                            <div id="group-fields-primefinannee" className="content-composants">
                                <div id="group-field-soumise" className="group-field">
                                    <div className="group-label">
                                        <label aria-hidden="true" htmlFor="transports-publics" className="field-label">{getKeyFromKeyId("SOUMISE")}</label>
                                      </div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("EndYearBonusAmountForemSubmitted")}className={GetInputFieldCssClass(errors?.EndYearBonusAmountForemSubmitted?true:false)}maxLength={256} placeholder="0 €" id="transports-publics" />
                                    </div>
                                    {errors?.EndYearBonusAmountForemSubmitted && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.EndYearBonusAmountForemSubmitted.message as any)}</p>}
                                </div>
                                <div id="group-field-prive" className="group-field">
                                    <div className="group-label">
                                        <label aria-hidden="true" htmlFor="transport-prive" className="field-label">{getKeyFromKeyId("NON_SOUMISE")}</label>
                                     </div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("EndYearBonusAmountForemNotSubmitted")}className={GetInputFieldCssClass(errors?.EndYearBonusAmountForemNotSubmitted?true:false)}maxLength={256} placeholder="0 €" id="transport-prive" />
                                    </div>
                                    {errors?.EndYearBonusAmountForemNotSubmitted && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.EndYearBonusAmountForemNotSubmitted.message as any)}</p>}
                                </div>
                            </div>
                        </section>
                        }



                    </div>
                    <div id="column-right" className="column-composants w-node-_4f31b388-4675-a6f2-83c3-bf934b7f28b4-80011528">
                        <section id="section-p-cules" data-w-id="7b7aeb6b-c6b6-218c-3b71-755e89ef95bb" style={getSectionTogglerStyle(section3)} className="section-composants w-node-_7b7aeb6b-c6b6-218c-3b71-755e89ef95bb-80011528">
                            <div id="dropdown-title-pecules" tabIndex={0} data-w-id="d13c0416-c4b1-5c7e-af37-18649d323f95" className="dropdow-titre" onClick={() => toggleSection(3)}>
                                <h2 className="title-section-composants">{getKeyFromKeyId("BONUS")}</h2><img loading="lazy" className={"selectDropDownImg"} src="images/ic-down-celeste.svg" alt="" />
                            </div>
                            <div id="group-fields-pecules" className="content-composants">
                                <h3 className="sub-title-section-composant">{getKeyFromKeyId("BONUS_CURRENT")}</h3>
                                <div id="group-field-double-courant" className="group-field">
                                    <div className="group-label"><label htmlFor="double-pecule-courant" className="field-label">{getKeyFromKeyId("DOUBLE_PEC")}</label></div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("CurrentDoubleBonusAmount")}className={GetInputFieldCssClass(errors?.CurrentDoubleBonusAmount?true:false)}maxLength={256} placeholder="0 €" id="double-pecule-courant" />
                                    </div>
                                    {errors?.CurrentDoubleBonusAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.CurrentDoubleBonusAmount.message as any)}</p>}
                                </div>
                                <div id="group-field-compement-courant" className="group-field">
                                    <div className="group-label"><label aria-hidden="true" htmlFor="complement" className="field-label">{`${getKeyFromKeyId("COMPL_PEC_4S")} - ${getKeyFromKeyId("BONUS_CURRENT")}`}</label></div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("CurrentAdditionalBonusAmount")}className={GetInputFieldCssClass(errors?.CurrentAdditionalBonusAmount?true:false)}maxLength={256} placeholder="0 €" id="complement" />
                                    </div>
                                    {errors?.CurrentAdditionalBonusAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.CurrentAdditionalBonusAmount.message as any)}</p>}
                                </div>
                                <h3 className="sub-title-section-composant">{getKeyFromKeyId("BONUS_PREVIOUS")}</h3>
                                <div id="group-field-simple-precedent" className="group-field">
                                    <div aria-hidden="true" className="group-label"><label htmlFor="simple-pecule" className="field-label">{getKeyFromKeyId("SIMPLE_PEC")}</label></div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("PreviousBonusAmount")}className={GetInputFieldCssClass(errors?.PreviousBonusAmount?true:false)}maxLength={256} placeholder="0 €" id="simple-pecule" />
                                    </div>
                                    {errors?.PreviousBonusAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.PreviousBonusAmount.message as any)}</p>}
                                </div>
                                <div id="group-field-double-precedent" className="group-field">
                                    <div className="group-label"><label aria-hidden="true" htmlFor="double-pecule-precedent" className="field-label">{getKeyFromKeyId("DOUBLE_PEC")}</label></div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("PreviousDoubleBonusAmount")}className={GetInputFieldCssClass(errors?.PreviousDoubleBonusAmount?true:false)}maxLength={256} placeholder="0 €" id="double-pecule-precedent" />
                                    </div>
                                    {errors?.PreviousDoubleBonusAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.PreviousDoubleBonusAmount.message as any)}</p>}
                                </div>
                                <div id="group-field-complement-precedent" className="group-field">
                                    <div className="group-label"><label aria-hidden="true" htmlFor="complement-precedent" className="field-label">{getKeyFromKeyId("COMPL_PEC")}</label></div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("PreviousAdditionalBonusAmount")}className={GetInputFieldCssClass(errors?.PreviousAdditionalBonusAmount?true:false)}maxLength={256} placeholder="0 €" id="complement-precedent" />
                                    </div>
                                    {errors?.PreviousAdditionalBonusAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.PreviousAdditionalBonusAmount.message as any)}</p>}
                                </div>
                                <h3 className="sub-title-section-composant">{getKeyFromKeyId("BONUS_NEXT")}</h3>
                                <div id="group-field-simple-anticipes" className="group-field">
                                    <div className="group-label"><label aria-hidden="true" htmlFor="vacances-anticipes" className="field-label">{`${getKeyFromKeyId("SIMPLE_PEC")} - ${getKeyFromKeyId("BONUS_NEXT")}`}</label></div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("AdvanceBonusAmount")}className={GetInputFieldCssClass(errors?.AdvanceBonusAmount?true:false)}maxLength={256} placeholder="0 €" id="vacances-anticipes" />
                                    </div>
                                    {errors?.AdvanceBonusAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.AdvanceBonusAmount.message as any)}</p>}
                                </div>
                                <div id="group-field-double-anticipes" className="group-field">
                                    <div className="group-label"><label aria-hidden="true" htmlFor="vacances-anticipes-double" className="field-label">{`${getKeyFromKeyId("DOUBLE_PEC")} - ${getKeyFromKeyId("BONUS_NEXT")}`}</label></div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("AdvanceDoubleBonusAmount")}className={GetInputFieldCssClass(errors?.AdvanceDoubleBonusAmount?true:false)}maxLength={256} placeholder="0 €" id="vacances-anticipes-double" />
                                    </div>
                                    {errors?.AdvanceDoubleBonusAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.AdvanceDoubleBonusAmount.message as any)}</p>}
                                </div>
                                <div id="group-field-complement-anticipes" className="group-field">
                                    <div className="group-label"><label aria-hidden="true" htmlFor="vacances-anticipes-complement" className="field-label">{`${getKeyFromKeyId("COMPL_PEC")} - ${getKeyFromKeyId("BONUS_NEXT")}`}</label></div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("AdvanceAdditionalBonusAmount")}className={GetInputFieldCssClass(errors?.AdvanceAdditionalBonusAmount?true:false)}maxLength={256} placeholder="0 €" id="vacances-anticipes-complement" />
                                    </div>
                                    {errors?.AdvanceAdditionalBonusAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.AdvanceAdditionalBonusAmount.message as any)}</p>}
                                </div>
                            </div>
                        </section>
                        <section id="section-transports" data-w-id="0bbf6d0c-e764-7d78-fb82-0f83dda7643f" style={getSectionTogglerStyle(section4)} className="section-composants last-child w-node-_0bbf6d0c-e764-7d78-fb82-0f83dda7643f-4f6cf1d2">
                            <div id="dropdown-title-transports" tabIndex={0} data-w-id="b806931d-cb39-2257-1d76-ff6800467242" className="dropdow-titre" onClick={() => toggleSection(4)}>
                                <h2 className="title-section-composants">{getKeyFromKeyId("TRANSPORTATION")}</h2><img loading="lazy" className={"selectDropDownImg"} src="images/ic-down-celeste.svg" alt="" />
                            </div>
                            <div id="group-fields-transports" className="content-composants">
                                <div id="group-field-publics" className="group-field">
                                    <div className="group-label">
                                        <label aria-hidden="true" htmlFor="transports-publics" className="field-label">{getKeyFromKeyId("ABON_SOCIAL_PUBLIC")}</label>
                                        <MUITooltipCustom tooltipText={getKeyFromKeyId("TOOLTIP_HELP_PUBLIC_TRANSPORT")} buttonAltText={getKeyFromKeyId("TOOLTIP_HELP_ALT_PUBLIC_TRANSPORT")} placement="top"/>
                                    </div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("PublicTransportationAmount")}className={GetInputFieldCssClass(errors?.PublicTransportationAmount?true:false)}maxLength={256} placeholder="0 €" id="transports-publics" />
                                    </div>
                                    {errors?.PublicTransportationAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.PublicTransportationAmount.message as any)}</p>}
                                </div>
                                <div id="group-field-prive" className="group-field">
                                    <div className="group-label">
                                        <label aria-hidden="true" htmlFor="transport-prive" className="field-label">{getKeyFromKeyId("ABON_SOCIAL_PRIVE")}</label>
                                        <MUITooltipCustom tooltipText={getKeyFromKeyId("TOOLTIP_HELP_PRIVATE_TRANSPORT")} buttonAltText={getKeyFromKeyId("TOOLTIP_HELP_ALT_PRIVATE_TRANSPORT")} placement="top"/>
                                    </div>
                                    <div className="text-field-icon">
                                        <input type="number" {...register("PrivateTransportationAmount")}className={GetInputFieldCssClass(errors?.PrivateTransportationAmount?true:false)}maxLength={256} placeholder="0 €" id="transport-prive" />
                                    </div>
                                    {errors?.PrivateTransportationAmount && <p className='inputErrorHelper'>{getKeyFromKeyId(errors.PrivateTransportationAmount.message as any)}</p>}
                                </div>
                            </div>
                        </section>
                    </div>
                </form>
            </div>
        </>
    );
}

export default Step3Advanced;